/**
 * The guides hub. Each row carries the guide's honest answer rather than its
 * standfirst, so the list settles the premise before the click for anyone who
 * only wanted to know whether the thing was possible.
 */

import type { ContentLang } from "@fazly/shared/contentLang";
import { Link } from "@tanstack/react-router";

import { HOWTO_SLUGS, howtoPath } from "../../lib/howto/index";
import type { HowtoBundle } from "../../lib/howto/types";
import type { HowtoUi } from "../../lib/howto/ui";
import { ContentFooter } from "../ContentFooter";

export function HowtoIndex({
  lang,
  ui,
  bundle,
}: {
  lang: ContentLang;
  ui: HowtoUi;
  bundle: HowtoBundle;
}) {
  return (
    <main className="mx-auto w-full max-w-3xl px-6 py-12 sm:py-16">
      <h1 className="font-display text-[clamp(2rem,7vw,3rem)] leading-[1.1] font-bold tracking-tight text-ink">
        {ui.indexH1}
      </h1>
      <p className="mt-4 max-w-xl text-lg leading-relaxed text-ink2">
        {ui.indexStandfirst}
      </p>

      <ul className="mt-10 divide-y divide-hair border-y-[2.5px] border-ink">
        {HOWTO_SLUGS.map((slug) => (
          <li key={slug}>
            <Link
              to={howtoPath(slug, lang)}
              className="group flex flex-col gap-1 py-5 transition-colors hover:bg-inset"
            >
              <span className="font-display text-xl font-bold text-ink group-hover:text-brand">
                {bundle[slug].h1}
              </span>
              <span className="text-[15px] leading-relaxed text-ink2">
                {bundle[slug].standfirst}
              </span>
            </Link>
          </li>
        ))}
      </ul>

      <ContentFooter lang={lang} />
    </main>
  );
}
